<div class="main-content-wrapper">
	<div class="main-content">
		<header class="main-content-header">
			<h1>Shares &nbsp;&nbsp;&nbsp;<a href="javascript:" (click)="resetCreateShare(); loadShares()"><em class="fa fa-redo-alt" title="Refresh Shares"></em></a></h1>
			<div class="pull-right">
				<div class="button-container" *ngIf="loadingCanCreate"><em class="fas fa-circle-notch fa-spin"></em></div>
				<div class="button-container" *ngIf="canCreate && (orgs.length > 0 || groups.length > 0) && !loadingCanCreate">
					<button class="btn btn-primary" (click)="openCreateShare()">Create File Share</button>
				</div>
			</div>
		</header>
	</div>
</div>
<div class="main-content-area loading in" *ngIf="!sharesLoaded">&nbsp;</div>
<div class="main-content-area" [ngClass]="{'loading in': loading }" *ngIf="sharesLoaded">
	<div class="right-container" [ngClass]="{'expanded': rightContainerExpanded, 'collapsed': !rightContainerExpanded}">
		<div [ngClass]="{'loading in': loadingRightPanel }">
			<div class="title">{{ !updateShare ? 'Create' : 'Edit' }} File Share</div>
			<div class="form" [ngClass]="{'loading in': loading }">
				<ng-container *ngFor="let field of fields">
					<div class="field-container" *ngIf="field.property !== -1 && field.property !== 100">
						<label [for]="field.property" class="form-label"><span *ngIf="field.required">*</span>{{ field.name }}</label>
						<div *ngIf="field.dataType === 1">
							<input type="text" [id]="field.property" [(ngModel)]="formData[field.property]" class="form-control" (change)="inputChanged()">
						</div>
						<div *ngIf="field.dataType === 2 || field.dataType === 3">
							<input type="number" [id]="field.property" [(ngModel)]="formData[field.property]" class="form-control" (change)="inputChanged()">
						</div>
						<div *ngIf="field.dataType === 5 || field.dataType === 6 || field.dataType === 7">
							<input type="text" [id]="field.property" [(ngModel)]="formData[field.property]" bsDatepicker class="form-control" (change)="inputChanged()" autoComplete="off">
						</div>
						<div *ngIf="field.dataType === 8">
							<div class="switch-row">
								<div class="switch">
									<input [id]="'completed' + i" type="checkbox" [(ngModel)]="formData[field.property]" class="switch-input" (change)="inputChanged()">
									<label [for]="'completed' + i" class="switch-label">Switch</label>
								</div>
							</div>
						</div>

						<div *ngIf="field.dataType === 9">
							<ng-select class="typeahead form-typeahead" [addTag]="optionLists[field.property] && optionLists[field.property].mconnectUserField" [items]="getOptionListItems(field.property)" [clearable]="true" bindLabel="name" bindValue="id" [id]="field.property" [(ngModel)]="formData[field.property]" (change)="selectFieldValueChanged(field); checkAddUser(field, $event)">
							</ng-select>
						</div>

						<div *ngIf="field.dataType === 10">
							<ng-select class="typeahead form-typeahead" [addTag]="optionLists[field.property] && optionLists[field.property].mconnectUserField" [items]="getOptionListItems(field.property)" [clearable]="true" bindLabel="name" bindValue="id" [id]="field.property" [(ngModel)]="tempFormData[field.property]" (change)="multiselectChanged(field, $event); selectFieldValueChanged(field); checkAddUser(field, $event)">
							</ng-select>
							<div class="multiselect-value-row">
								<span *ngFor="let value of formData[field.property]; let i = index">
									<span class="multiselect-value">{{ value.name }} <em class="fas fa-times" (click)="removeMultiselect(field, i)"></em></span>
								</span>
							</div>
						</div>

						<div *ngIf="field.dataType === 13">
							<textarea [id]="field.property" [(ngModel)]="formData[field.property]" class="form-control" (change)="inputChanged()"></textarea>
						</div>
					</div>
				</ng-container>
			</div>
			<div class="footer">
				<ng-container *ngIf="!authService.isAdmin()">
					You must enter an organization or group.
				</ng-container>
				<ng-container>
					<div class="right">
						<button type="button" class="btn btn-md" [disabled]="loading" (click)="openCreateShare();">Cancel</button>
						<button type="button" class="btn btn-md" [disabled]="!validForm() || loading" (click)="!updateShare ? createShare() : updateFileShare()">Finish</button>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="main-content-body">
		<div class="content-header-row">
			<div class="filter-options-container">
				Filter Shares: <input type="text" class="form-control" [id]="shareFilter" [(ngModel)]="shareFilter" (change)="inputChanged()">
			</div>
			<div class="expiredSharesContainer">
				<label class="text" for="showExpiredShares">Show Expired Shares&nbsp;</label>
				<div class="switch">
					<input id="showExpiredShares" type="checkbox" class="switch-input" [(ngModel)]="showExpiredShares" (ngModelChange)="loadShares()" />
					<label for="showExpiredShares" class="switch-label">Switch</label>
				</div>
			</div>
		</div>
		<table class="full-width table table-striped table-fixed has-locked-deleted has-locked-and-deleted file-share-listing">
			<thead>
				<tr>
					<th id="name" [(attr.colspan)]="nameColspan" class="title-cell sort" (click)="updateSort('name')">Name <em *ngIf="shareSortCol == 'name' && !shareSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="shareSortCol == 'name' && shareSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="owner" *ngIf="layoutService.getFileShareListingHeaders().owner" class="expiration sort" (click)="updateSort('ownerName')">Owner <em *ngIf="shareSortCol == 'ownerName' && !shareSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="shareSortCol == 'ownerName' && shareSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="organization" *ngIf="layoutService.getFileShareListingHeaders().org" class="expiration sort" (click)="updateSort('orgNames')">Organization(s) <em *ngIf="shareSortCol == 'orgNames' && !shareSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="shareSortCol == 'orgNames' && shareSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="group" *ngIf="layoutService.getFileShareListingHeaders().group" class="expiration sort" (click)="updateSort('groupNames')">Group(s) <em *ngIf="shareSortCol == 'groupNames' && !shareSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="shareSortCol == 'groupNames' && shareSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<!--
					<th id="createdBy" class="expiration" (click)="updateSort('createdByName')">Created by</th>
					-->
					<th id="expiration" *ngIf="layoutService.getFileShareListingHeaders().expDate" class="expiration sort" (click)="updateSort('expiration')">Expiration Date <em *ngIf="shareSortCol == 'expiration' && !shareSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="shareSortCol == 'expiration' && shareSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="revisions"></th>
					<th id="share"></th>
					<th id="upload"></th>
					<th id="edit"></th>
					<th id="delete"></th>
					<th id="column-select" (clickOutside)="saveHeaderChanges()">
						<em class='icon fas fa-table' (click)="editHeaders = !editHeaders" title="Select Columns"></em>
						<div *ngIf="editHeaders" class="header-dropdown">
							<label *ngFor="let header of getHeaderKeys(); let i = index">
								<input type="checkbox" [(ngModel)]="changedHeaders[header]" (change)="changeHeader(header, $event.target.checked)" />
								<span>{{getFormattedHeaders(i)}}</span>
							</label>
							<label>
								<a href="javascript:" (click)="saveHeaderChanges()">Done</a>
							</label>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let share of getSortedFilteredShares(); let i = index">
					<tr class="file-share">
						<td class="title-cell" [(attr.colspan)]="nameColspan">
							<div class="title-overflow">
								<em class="fas fa-circle-notch fa-spin icon" *ngIf="loadingIndex == i"></em>
								<a *ngIf="loadingIndex !== i" href="javascript:" (click)="shareClicked(share, i)"><em class="icon" [ngClass]="activeShare == i ? 'fas fa-minus-circle' : 'fas fa-plus-circle'" [title]="activeShare == i ? 'Close Share' : 'Expand Share'"></em></a>
								<a href="javascript:" (click)="shareClicked(share, i)" class="title" *ngIf="!share?.expired">{{ share.name }}</a>
								<span *ngIf="share?.expired" class="expired-share-title" tooltip="Share is Expired" placement="bottom">{{ share.name }}</span>
							</div>
						</td>
						<td class="expiration" *ngIf="layoutService.getFileShareListingHeaders().owner">
							<div class="overflow">{{ share.ownerName }}</div>
						</td>
						<td class="expiration" *ngIf="layoutService.getFileShareListingHeaders().org">
							<div class="overflow">{{ share.orgNames }}</div>
						</td>
						<td class="expiration" *ngIf="layoutService.getFileShareListingHeaders().group">
							<div class="overflow">{{ share.groupNames }}</div>
						</td>
						<!--
						<td class="expiration">
							<div class="overflow">{{share.createdByName }}</div>
						</td>
						-->
						<td class="expiration" *ngIf="layoutService.getFileShareListingHeaders().expDate">
							<div class="overflow" *ngIf="share?.expiration">{{ share.expiration | date: defaultDateFormat ?? 'MM/dd/yyyy'}}</div><span *ngIf="!share?.expiration">-</span>
						</td>
						<td class="icon-cell"></td>
						<td class="icon-cell"></td>
						<td class="icon-cell"></td>
						<td class="icon-cell"></td>
						<td class="icon-cell"><a *ngIf="share.canModify" href="javascript:" (click)="updateShare = true; editFileShare(share)" tooltip="Edit Share" placement="bottom"><em class="fa fa-edit"></em></a></td>
						<td class="icon-cell"><a *ngIf="share.canModify" href="javascript:" (click)="openDeleteShare(share)" tooltip="Delete Share" placement="bottom"><em class="fas fa-trash"></em></a></td>
					</tr>
					<ng-container *ngIf="activeShare == i && loadingIndex == -1">
						<tr class="inner" *ngIf="share.docs.length > 1">
							<td colspan="5">
								<input class="icon" type="checkbox" id="checkAllInput" (change)="checkAll(share.docs, $event)" />
							</td>
							<td colspan="3">
								<button class="btn btn-primary download-button" [disabled]="!atLeastOneDocChecked(share.docs)" (click)="downloadSelected(share.docs)">Download Selected</button>
							</td>
							<td colspan="3">
								<button class="btn btn-primary download-button" (click)="downloadAll(share.docs)">Download All</button>
							</td>
						</tr>
						<ng-container *ngFor="let doc of share.docs; let j = index">
							<tr class="inner">
								<td colspan="7">
									<input *ngIf="share.docs.length > 1" type="checkbox" class="checkbox" [(ngModel)]="doc.checkedForDownload" (click)="docChecked(doc, $event)" />
									
									<em *ngIf="!objectTypeIcons[doc.type]" class="icon icon-file icon-other preview-icon" [ngClass]="[doc?.extension !== undefined ? 'icon-' + doc?.extension : '', share.docs.length > 1 ? 'left-margin-sm' : 'left-margin']" [title]="doc?.extension !== undefined ? doc.extension + ' File' : 'Shared File'"></em>
									<em *ngIf="objectTypeIcons[doc.type]" class="icon icon-file icon-other preview-icon" [ngStyle]="{'background': 'url(' + objectTypeIcons[doc.type].changingThisBreaksApplicationSecurity + ') no-repeat', 'background-size': 'contain'}" [ngClass]="share.docs.length > 1 ? 'left-margin-sm' : 'left-margin'" [title]="doc?.extension !== undefined ? doc.extension + ' File' : 'Shared File'"></em>
									<a href="javascript:" (click)="docClicked(doc, i, j, 0, 0, false)">{{ doc.name }}{{ doc.extension ? '.' + doc.extension : '' }}</a>
									<em *ngIf="doc.members" class="icon fas fa-copy expander" tooltip="Document collection" placement="right"></em>
									<em *ngIf="doc.files" class="icon fas fa-copy expander" tooltip="Multi-file document" placement="right"></em>
									<em *ngIf="doc.latestCheckedInVersion && doc.version !== doc.latestCheckedInVersion" class="icon fas fa-exclamation-circle expander" [tooltip]="'NOTE: Version ' + doc.version + ' is not the latest version'" placement="right"></em>
								</td>
								<td class="icon-cell">
									<ng-container *ngIf="share.links.length > 0"><a class="icon-link file-download" href="javascript:" (click)="openShareLinkModal(share, doc)"><em class="fas fa-share" tooltip="Share" placement="bottom"><span class="sr-only">Share</span></em></a></ng-container>
								</td>
								<td class="icon-cell">
									<ng-container *ngIf="!doc.files && share.permissions?.indexOf(5) > -1"><a class="icon-link file-download" href="javascript:" (click)="download(share, doc, 0)"><em class="fas fa-download" tooltip="Download" placement="bottom"><span class="sr-only">Download</span></em></a></ng-container>
									<!--
								<ng-container *ngIf="share.permissions?.indexOf(3) > -1"><a class="icon-link" href="javascript:"><em class="fas fa-file-upload" tooltip="Upload Revision" placement="bottom"><span class="sr-only">Upload Revision</span></em></a></ng-container>
								-->
								</td>
								<td class="icon-cell">
									<ng-container *ngIf="!doc.members && !doc.files && share.permissions?.indexOf(6) > -1">
										<label [for]="'revision_' + doc.id" class="icon-link-label">
											<em class="fas fa-file-upload icon-link" tooltip="Upload Document" placement="bottom"></em>
										</label>
										<input type="file" [id]="'revision_' + doc.id" (change)="reviseFile(share, doc, 0, $event)">
									</ng-container>
								</td>
								<td class="icon-cell">
									<ng-container *ngIf="share.permissions?.indexOf(10) > -1"><a class="icon-link" href="javascript:" (click)="removeFile(share, doc, j)"><em class="fas fa-folder-minus" tooltip="Remove File from Share" placement="bottom"><span class="sr-only">Remove File from Share</span></em></a></ng-container>
								</td>
							</tr>
							<ng-container *ngIf="doc.members && activeDoc === j">
								<tr *ngFor="let member of doc.members; let k = index" class="inner indent">
									<td colspan="7">
										<em *ngIf="!objectTypeIcons[0]" class="icon icon-file icon-other preview-icon left-margin" [ngClass]="member?.extension !== undefined ? 'icon-' + member?.extension : ''" [title]="member?.extension !== undefined ? member.extension + ' File' : 'Shared File'"></em>
										<em *ngIf="objectTypeIcons[0]" class="icon icon-file icon-other preview-icon left-margin" [ngStyle]="{'background': 'url(' + objectTypeIcons[0].changingThisBreaksApplicationSecurity + ') no-repeat', 'background-size': 'contain'}" [title]="member?.extension !== undefined ? member.extension + ' File' : 'Shared File'"></em>
										<a href="javascript:" (click)="fileClicked(doc, i, j, 0, k, false)">{{ member.name }}{{ member.extension ? '.' + member.extension : '' }}</a>
									</td>
									<td class="icon-cell">
										<ng-container *ngIf="share.permissions?.indexOf(5) > -1"><a class="icon-link file-download" href="javascript:" (click)="download(share, member, 0)"><em class="fas fa-download" tooltip="Download" placement="bottom"><span class="sr-only">Download</span></em></a></ng-container>
									</td>
									<td class="icon-cell">
										<ng-container *ngIf="share.permissions?.indexOf(6) > -1">
											<label [for]="'revision_' + doc.id" class="icon-link-label">
												<em class="fas fa-file-upload icon-link" tooltip="Upload Document" placement="bottom"></em>
											</label>
											<input type="file" [id]="'revision_' + doc.id" (change)="reviseFile(share, member, 0, $event)">
										</ng-container>
									</td>
									<td></td>
								</tr>
							</ng-container>
							<ng-container *ngIf="doc.files && activeDoc === j">
								<tr *ngFor="let file of doc.files; let k = index" class="inner indent">
									<td colspan="8">
										<em *ngIf="!objectTypeIcons[0]" class="icon icon-file icon-other preview-icon left-margin" [ngClass]="file?.extension !== undefined ? 'icon-' + file?.extension : ''" [title]="file?.extension !== undefined ? file.extension + ' File' : 'Shared File'"></em>
										<em *ngIf="objectTypeIcons[0]" class="icon icon-file icon-other preview-icon left-margin" [ngStyle]="{'background': 'url(' + objectTypeIcons[0].changingThisBreaksApplicationSecurity + ') no-repeat', 'background-size': 'contain'}" [title]="file?.extension !== undefined ? file.extension + ' File' : 'Shared File'"></em>
										<a href="javascript:" (click)="fileClicked(doc, i, j, 0, k, false)">{{ file.name }}{{ file.extension ? '.' + file.extension : '' }}</a>
									</td>
									<td class="icon-cell">
										<ng-container *ngIf="share.permissions?.indexOf(5) > -1"><a class="icon-link file-download" href="javascript:" (click)="download(share, doc, k)"><em class="fas fa-download" tooltip="Download" placement="bottom"><span class="sr-only">Download</span></em></a></ng-container>
									</td>
									<td class="icon-cell">
										<ng-container *ngIf="share.permissions?.indexOf(6) > -1">
											<label [for]="'revision_' + doc.id" class="icon-link-label">
												<em class="fas fa-file-upload icon-link" tooltip="Upload Document" placement="bottom"></em>
											</label>
											<input type="file" [id]="'revision_' + doc.id" (change)="reviseFile(share, doc, k, $event)">
										</ng-container>
									</td>
									<td>
									</td>
								</tr>
							</ng-container>
						</ng-container>
						<tr *ngIf="!share.hasDocs" class="inner">
							<td colspan="11">
								<div class="no-shared-message">No shared documents</div>
							</td>
						</tr>
						<tr *ngIf="share.hasEmails" class="inner">
							<td colspan="11" class="add-link-cell">
								<ng-container *ngIf="!displayEmails">
									<a href="javascript:" (click)="displayEmails = true"><em class="sub icon fas fa-plus-circle" title="Display Correspondence Emails"></em></a> <a href="javascript:" (click)='displayEmails = true'>Display Correspondence Emails</a>
								</ng-container>
								<ng-container *ngIf="displayEmails">
									<a href="javascript:" (click)="displayEmails = false"><em class="sub icon fas fa-minus-circle" title="Hide Correspondence Emails"></em></a> <a href="javascript:" (click)='displayEmails = false'>Hide Correspondence Emails</a>
								</ng-container>
							</td>
						</tr>
						<ng-container *ngIf="share.hasEmails && displayEmails">
							<tr *ngFor="let email of share.emails; let j = index" class="inner indent">
								<td>
									<em *ngIf="!objectTypeIcons[0]" class="icon icon-file icon-other preview-icon left-margin" [ngClass]="email?.extension !== undefined ? 'icon-' + email?.extension : ''" title="Correspondence Email"></em>
									<em *ngIf="objectTypeIcons[0]" class="icon icon-file icon-other preview-icon left-margin" [ngStyle]="{'background': 'url(' + objectTypeIcons[0].changingThisBreaksApplicationSecurity + ') no-repeat', 'background-size': 'contain'}" title="Correspondence Email"></em>
									<a href="javascript:" (click)="fileClicked(email, i, j, 0, 0, true)">{{ email.name }}.{{ email.extension }}</a>
								</td>
								<td colspan="7"></td>
								<td class="icon-cell">
									<!-- <ng-container *ngIf="share.permissions?.indexOf(5) > -1"><a class="icon-link file-download" href="javascript:" (click)="download(share, email)"><em class="fas fa-download" tooltip="Download" placement="bottom"><span class="sr-only">Download</span></em></a></ng-container> -->
								</td>
								<td>
								</td>
								<td class="icon-cell">
									<!-- <ng-container *ngIf="share.permissions?.indexOf(10) > -1"><a class="icon-link" href="javascript:" (click)="removeFile(share, email, j)"><em class="fas fa-folder-minus" tooltip="Remove File from Share" placement="bottom"><span class="sr-only">Remove File from Share</span></em></a></ng-container> -->
								</td>
							</tr>
						</ng-container>
						<tr *ngIf="share.canModify" class="inner">
							<td class="add-document-cell" [colSpan]="displayAddDocument ? 9 : 11">
								<a *ngIf="!displayAddDocument" class="no-shared-link" href="javascript:" (click)='displayAddDocument = true'>+ Add document to share</a>
								<ng-container *ngIf="displayAddDocument">
									<div class="typeahead-container-search">
										<ng-select class="typeahead form-typeahead" [items]="searchDocs" [clearable]="true" bindLabel="title" bindValue="objVer.id" id="shareDoc" [(ngModel)]="shareDoc" (change)="shareDocChanged($event)" (search)="shareDocSearch($event)" placeholder="Find a Document"></ng-select>
									</div>
									<a href="javascript:" (click)="openAdvancedSearch(share)">Advanced Search</a>
								</ng-container>
							</td>
							<td *ngIf="displayAddDocument" class="icon-cell">
								<em tooltip="Cancel Add Document" placement="bottom" class="fas fa-times-circle" (click)='resetAddDoc()'></em>
							</td>
							<td *ngIf="displayAddDocument" class="icon-cell">
								<em tooltip="Add Document" placement="bottom" class="fas fa-check-circle" (click)='addFileToShare(share)'></em>
							</td>
						</tr>
						<tr *ngIf="share.permissions && share.permissions?.indexOf(3) > -1" class="inner" [ngClass]="{'active': showDragDropBorder }" dragDrop (filesDropped)="uploadFiles(share, $event)" (filesDraggedOver)="showDragDropBorder = true" (filesDraggedLeave)="showDragDropBorder = false">
							<td colspan="11">
								<div>
									<label [for]="'uploader_' + share.id" class="no-shared-link">
										+ Click here or drag files to upload to share
									</label>
									<input type="file" [id]="'uploader_' + share.id" (change)="uploadFiles(share, $event)" multiple>
								</div>
							</td>
						</tr>
						<ng-container *ngIf="share.canModify">
							<tr *ngFor="let link of share.links; let k = index" class="inner">
								<td colspan="7" class="add-link-cell">
									<em *ngIf="!objectTypeIcons[link.type] && link !== linkToEdit" class="icon icon-file fa fa-link left-margin" title="Share Link"></em>
									<em *ngIf="objectTypeIcons[link.type] && link !== linkToEdit" class="icon icon-file left-margin" [ngStyle]="{'background': 'url(' + objectTypeIcons[link.type].changingThisBreaksApplicationSecurity + ') no-repeat', 'background-size': 'contain'}" title="Share Link"></em>

									<span class="link-name" *ngIf="link !== linkToEdit">
										<a href="javascript:" (click)="openShareLink(link)">{{ getLinkName(link) }}</a> <em *ngIf="link.scope === 5 && link.users.length > 1" class="fas fa-user tooltip-icon users-link-icon" [tooltip]="ShareLinkUsers" placement="bottom"></em>
										<ng-template #ShareLinkUsers>
											{{ link.userNames }}
										</ng-template>
									</span>

									<ng-container *ngIf="link === linkToEdit">
										<div class="typeahead-container scope">
											<select class="form-control" [(ngModel)]="formattedLink.scope">
												<option *ngFor="let scope of scopes" [value]="scope.id">{{ scope.name }}</option>
											</select>
										</div>
										<div *ngIf="formattedLink.scope == 1" class="typeahead-container">
											<select class="form-control" disabled></select>
										</div>
										<div *ngIf="formattedLink.scope == 2" class="typeahead-container">
											<ng-select class="typeahead" [items]="getScopeableOrgs(share)" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select Organization" [(ngModel)]="formattedLink.org">
											</ng-select>
										</div>
										<div *ngIf="formattedLink.scope == 3" class="typeahead-container">
											<ng-select class="typeahead" [items]="getScopeableGroups(share)" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select Group" [(ngModel)]="formattedLink.group">
											</ng-select>
										</div>
										<div *ngIf="formattedLink.scope == 4" class="typeahead-container">
											<ng-select class="typeahead" [items]="users" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select User" [(ngModel)]="formattedLink.user">
											</ng-select>
										</div>
										<div *ngIf="formattedLink.scope == 5" class="typeahead-container">
											<ng-select class="typeahead" [items]="users" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select User" [(ngModel)]="formattedLink.user" (change)="addUserToUsersScope($event, formattedLink)">
											</ng-select>
											<div class="multiselect-value-row" *ngIf="formattedLink.users">
												<span *ngFor="let userId of formattedLink.users; let i = index">
													<span class="multiselect-value">{{ getUserName(userId) }} <em class="fas fa-times" (click)="removeLinkUser(formattedLink, i)"></em></span>
												</span>
											</div>
										</div>
									</ng-container>
									<div class="permission-icon-container">
										<span class="permission-icon">
											<em [tooltip]="getPermissionsName(8)" placement="bottom" class="fa fa-file-alt"></em>
										</span>
										<span class="permission-icon" (click)='link === linkToEdit ? formattedLink.download = !formattedLink.download : ""'>
											<em [tooltip]="getPermissionsName(5)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.download : link.permissions?.indexOf(5) == -1 }" class="fa fa-file-download"></em>
										</span>
										<!--
										<span class="permission-icon" (click)='link === linkToEdit ? formattedLink.delete = !formattedLink.delete : ""'>
											<em [tooltip]="getPermissionsName(4)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.delete : link.permissions?.indexOf(4) == -1 }" class="fa fa-trash"></em>
										</span>
										-->
										<span class="permission-icon" (click)='link === linkToEdit ? formattedLink.updateMetadata = !formattedLink.updateMetadata : ""'>
											<em [tooltip]="getPermissionsName(7)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.updateMetadata : link.permissions?.indexOf(7) == -1 }" class="fa fa-edit"></em>
										</span>
										<span class="permission-icon" (click)='link === linkToEdit ? formattedLink.updateDocument = !formattedLink.updateDocument : ""'>
											<em [tooltip]="getPermissionsName(6)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.updateDocument : link.permissions?.indexOf(6) == -1 }" class="fa fa-file-upload"></em>
										</span>
										<span class="permission-icon" (click)='link === linkToEdit ? formattedLink.create = !formattedLink.create : ""'>
											<em [tooltip]="getPermissionsName(3)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.create : link.permissions?.indexOf(3) == -1 }" class="fa fa-upload"></em>
										</span>
										<span class="permission-icon" *ngIf="commentsEnabled" (click)='link === linkToEdit ? formattedLink.comment = !formattedLink.comment : ""'>
											<em [tooltip]="getPermissionsName(2)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.comment : link.permissions?.indexOf(2) == -1 }" class="fa fa-comment"></em>
										</span>
										<span class="permission-icon" *ngIf="coauthorEnabled" (click)='link === linkToEdit ? formattedLink.coauthor = !formattedLink.coauthor : ""'>
											<em [tooltip]="getPermissionsName(9)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.coauthor : link.permissions?.indexOf(9) == -1 }" class="fa fa-user-edit"></em>
										</span>
										<span class="permission-icon" (click)='link === linkToEdit ? formattedLink.removeFromShare = !formattedLink.removeFromShare : ""'>
											<em [tooltip]="getPermissionsName(10)" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.removeFromShare : link.permissions?.indexOf(10) == -1 }" class="fa fa-folder-minus"></em>
										</span>
									</div>
								</td>

								<ng-container *ngIf="link !== linkToDelete && link !== linkToEdit">
									<td class="icon-cell"><a [href]="getLinkMailTo(link)" tooltip="Email Share URL" placement="bottom"><em class="fa fa-envelope"></em></a></td>
									<td class="icon-cell"><a href="javascript:" (click)="copyShareLink(link, undefined)" tooltip="Copy Share URL to clipboard" placement="bottom"><em class="fa fa-share"></em></a></td>
									<td class="icon-cell"><a href="javascript:" (click)="setLinkToEdit(link)" [tooltip]="link.checkedOut ? 'File Share Link is currently checked out' : 'Edit Share Link'" placement="bottom"><em class="fa fa-edit" [ngClass]="{'disabled-icon': link.checkedOut}"></em></a></td>
									<td class="icon-cell"><a href="javascript:" (click)="linkToDelete = link" tooltip="Delete Share Link" placement="bottom"><em class="fas fa-trash"></em></a></td>
								</ng-container>
								<ng-container *ngIf="link === linkToDelete || link === linkToEdit">
									<td></td>
									<td></td>
									<td class="icon-cell">
										<span><em [tooltip]="link === linkToDelete ? 'Cancel Share Link Deletion' : 'Cancel Share Link Edits'" placement="bottom" class="fas fa-times-circle" (click)='link === linkToDelete ? linkToDelete = {} : linkToEdit = {}'></em></span>
									</td>
									<td class="icon-cell">
										<span><em [tooltip]="link === linkToDelete ? 'Confirm Share Link Deletion' : 'Confirm Share Link Edits'" placement="bottom" class="fas fa-check-circle" (click)='link === linkToDelete ? deleteSingleLink(share, k) : editSingleLink(share, k)'></em></span>
									</td>
								</ng-container>
							</tr>
						</ng-container>
						<tr *ngIf="share.canModify && !share.hasLinks" class="inner">
							<td colspan="11">
								<div class="no-shared-message">No secure links</div>
							</td>
						</tr>
						<tr *ngIf="share.canModify" class="inner">
							<td class="add-link-cell" colspan="9">
								<ng-container *ngIf="!displayAddLink">
									<a class="no-shared-link" href="javascript:" (click)='displayAddLink = true'>+ Add link to share</a>
								</ng-container>
								<ng-container *ngIf="displayAddLink">
									<div class="typeahead-container">
										<select class="form-control" [(ngModel)]="singleLink.scope">
											<option *ngFor="let scope of scopes" [value]="scope.id">{{ scope.name }}</option>
										</select>
									</div>
									<div class="typeahead-container">
										<select *ngIf="singleLink.scope == 1" class="form-control" disabled></select>
										<ng-select *ngIf="singleLink.scope == 2" class="typeahead" [items]="getScopeableOrgs(share)" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select Organization" [(ngModel)]="singleLink.org"></ng-select>
										<ng-select *ngIf="singleLink.scope == 3" class="typeahead" [items]="getScopeableGroups(share)" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select Group" [(ngModel)]="singleLink.group"></ng-select>
										<ng-select *ngIf="singleLink.scope == 4" class="typeahead" [addTag]="true" [items]="users" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select User" [(ngModel)]="singleLink.user" (change)="checkAddUserScope($event, false)"></ng-select>
										<ng-select *ngIf="singleLink.scope == 5" class="typeahead" [addTag]="true" [items]="users" [clearable]="true" bindLabel="title" bindValue="objVer.id" placeholder="Select User" [(ngModel)]="singleLink.user" (change)="addUserToUsersScope($event, singleLink)"></ng-select>
										<div class="multiselect-value-row" *ngIf="singleLink.scope == 5 && singleLink.users">
											<span *ngFor="let userId of singleLink.users; let i = index">
												<span class="multiselect-value">{{ getUserName(userId) }} <em class="fas fa-times" (click)="removeLinkUser(singleLink, i)"></em></span>
											</span>
										</div>
									</div>
									<div class="permission-icon-container">
										<span class="permission-icon">
											<em [tooltip]="getPermissionsName(8)" placement="bottom" class="fa fa-file-alt"></em>
										</span>
										<span class="permission-icon disabled" (click)='singleLink.download = !singleLink.download'>
											<em [tooltip]="getPermissionsName(5)" placement="bottom" class="fa fa-file-download" [ngClass]="{'disabled': !singleLink.download }"></em>
										</span>
										<!--
										<span class="permission-icon disabled" (click)='singleLink.delete = !singleLink.delete'>
											<em [tooltip]="getPermissionsName(4)" placement="bottom" class="fa fa-trash" [ngClass]="{'disabled': !singleLink.delete }"></em>
										</span>
										-->
										<span class="permission-icon disabled" (click)='singleLink.updateMetadata = !singleLink.updateMetadata'>
											<em [tooltip]="getPermissionsName(7)" placement="bottom" class="fa fa-edit" [ngClass]="{'disabled': !singleLink.updateMetadata }"></em>
										</span>
										<span class="permission-icon disabled" (click)='singleLink.updateDocument = !singleLink.updateDocument'>
											<em [tooltip]="getPermissionsName(6)" placement="bottom" class="fa fa-file-upload" [ngClass]="{'disabled': !singleLink.updateDocument }"></em>
										</span>
										<span class="permission-icon disabled" (click)='singleLink.create = !singleLink.create'>
											<em [tooltip]="getPermissionsName(3)" placement="bottom" class="fa fa-upload" [ngClass]="{'disabled': !singleLink.create }"></em>
										</span>
										<span *ngIf="commentsEnabled" class="permission-icon disabled" (click)='singleLink.comment = !singleLink.comment'>
											<em [tooltip]="getPermissionsName(2)" placement="bottom" class="fa fa-comment" [ngClass]="{'disabled': !singleLink.comment }"></em>
										</span>
										<span *ngIf="coauthorEnabled" class="permission-icon disabled" (click)='singleLink.coauthor = !singleLink.coauthor'>
											<em [tooltip]="getPermissionsName(9)" placement="bottom" class="fa fa-user-edit" [ngClass]="{'disabled': !singleLink.coauthor}"></em>
										</span>
										<span class="permission-icon disabled" (click)='singleLink.removeFromShare = !singleLink.removeFromShare'>
											<em [tooltip]="getPermissionsName(10)" placement="bottom" class="fa fa-folder-minus" [ngClass]="{'disabled': !singleLink.removeFromShare }"></em>
										</span>
									</div>
								</ng-container>
							</td>
							<td class="icon-cell">
								<span *ngIf="displayAddLink"><em tooltip="Cancel Add Share Link" placement="bottom" class="fas fa-times-circle" (click)='displayAddLink = false; resetLink()'></em></span>
							</td>
							<td class="icon-cell">
								<span *ngIf="displayAddLink"><em tooltip="Add Share Link" placement="bottom" class="fas fa-check-circle" (click)='addShareLink(share)'></em></span>
							</td>
						</tr>
					</ng-container>
				</ng-container>

			</tbody>
		</table>

	</div>
</div>

<ng-template #fileShareDeleteModal>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-share"></em>Delete File Share</h5>
	</div>
	<div class="modal-body">
		Are you sure you want to delete File Share {{ deleteTarget.name }} and all of its links?
	</div>
	<div class="modal-footer message-footer">
		<button type="button" class="btn btn-md" (click)="modalRef.hide()">Cancel</button>
		<button type="button" class="btn btn-md" (click)="deleteFileShare()">Delete</button>
	</div>
</ng-template>

<ng-template #viewerModal>
	<div class="modal-body viewer">
		<div class="viewer-container" *ngIf="displayTab === 'viewer'">
			<app-widget-viewer [widgetSettings]="viewerModalSettings" [shareId]="getSortedFilteredShares()[selectedShareIndex].id"></app-widget-viewer>
		</div>
		<div *ngIf="displayTab === 'comments'">
			<div [ngClass]="{'loading in': loadingComments}">
				<div perfectScrollbar class="custom-scroll">
					<div class="metadata-table-outer">
						Comments ({{ commentsCount }})
						<div *ngIf="comments" class="comments">
							<div class="rootCommentResponse">
								<ng-container *ngIf="!authService.isAuthenticated()">
									<input type="text" name="commentUser" [(ngModel)]="newComment.user" placeholder="Name" class="form-control">
									<input type="text" name="commentEmail" [(ngModel)]="newComment.email" placeholder="E-mail (optional)" class="form-control">
								</ng-container>
								<textarea name="comment" [(ngModel)]="newComment.comment" placeholder="Enter a comment..." class="form-control"></textarea>
								<a href="javascript:" (click)="clearCommentForm()"><button type="reset">Cancel</button></a>
								<a><button type="button" (click)="onCommentSubmit()" [disabled]="!newComment.user || !newComment.comment">Reply</button></a>
							</div>
							<app-comments *ngFor="let comment of comments" (newComment)="onNewComment($event)" [comment]="comment" [item]="getSortedFilteredShares()[selectedShareIndex].docs[selectedDocumentIndex].id"></app-comments>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="displayTab === 'properties'">
			<div [ngClass]="{'loading in': loadingProperties}">
				<div perfectScrollbar class="custom-scroll">
					<div class="metadata-table-outer">
						<table class="table">
							<thead>
								<tr>
									<th id="property">Property</th>
									<th id="value">Value</th>
									<th id="values" class="center" *ngIf="hasEditableMultiSelect()">Multi-Select Values</th>
									<th id="remove" *ngIf="getSortedFilteredShares()[selectedShareIndex].permissions && getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(7) > -1"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let prop of docEditProps; let i = index">
									<td>
										{{ prop.name }}
									</td>
									<ng-container *ngIf="getSortedFilteredShares()[selectedShareIndex].permissions && getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(7) > -1">
										<td>
											<div *ngIf="prop.dataType === 1">
												<input type="text" [(ngModel)]="prop.value" class="form-control">
											</div>
											<div *ngIf="prop.dataType === 2 || prop.dataType === 3">
												<input type="number" [(ngModel)]="prop.value" class="form-control">
											</div>
											<div *ngIf="prop.dataType === 5 || prop.dataType === 6 || prop.dataType === 7">
												<input type="text" [(ngModel)]="prop.value" bsDatepicker class="form-control" autoComplete="off">
											</div>
											<div *ngIf="prop.dataType === 8">
												<div class="switch-row">
													<div class="switch">
														<input [id]="'additionalProps' + i" type="checkbox" class="switch-input" [(ngModel)]="prop.value" (ngModelChange)="onChange()" />
														<label [for]="'additionalProps' + i" class="switch-label">Switch</label>
													</div>
												</div>
											</div>
											<div *ngIf="prop.dataType === 9">
												<ng-select class="typeahead" [items]="getOptionListItems(prop.id)" [clearable]="false" bindLabel="name" bindValue="id" [placeholder]="prop.value ? prop.name : 'Select Value'" [(ngModel)]="prop.value">
												</ng-select>
											</div>
											<div *ngIf="prop.dataType === 10">
												<ng-select class="typeahead" [items]="getOptionListItems(prop.id)" [clearable]="false" bindLabel="name" bindValue="id" placeholder="Select Values" (change)="editMultiselectChanged(i, $event)">
												</ng-select>
											</div>
											<div *ngIf="prop.dataType === 13">
												<textarea [(ngModel)]="prop.value" class="form-control"></textarea>
											</div>
										</td>
										<td *ngIf="hasEditableMultiSelect()">
											<div *ngIf="prop.dataType === 10">
												<div *ngFor="let value of prop.value; let j = index">
													{{value.name}} <em class="fas fa-times red" (click)="removeEditMultiselectOption(prop, j)"></em>
												</div>
											</div>
										</td>
										<td *ngIf="getSortedFilteredShares()[selectedShareIndex].permissions && getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(7) > -1">
											<button class="btn-xs btn btn-danger" (click)="removeProp(i)">Remove</button>
										</td>
									</ng-container>
									<ng-container *ngIf="!getSortedFilteredShares()[selectedShareIndex].permissions || getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(7) === -1">
										<td>
											{{ prop.displayValue }}
										</td>
										<td *ngIf="hasEditableMultiSelect()"></td>
										<td *ngIf="getSortedFilteredShares()[selectedShareIndex].permissions && getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(7) > -1"></td>
									</ng-container>
								</tr>
							</tbody>
						</table>
						<button type="button" class="btn btn-success pull-right" *ngIf="docEditProps.length > 0 && getSortedFilteredShares()[selectedShareIndex].permissions && getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(7) > -1" (click)="saveProperties()">Update Properties</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer message-footer">
		<div class="col-md-6 left">

			<button class="btn btn-light btn-md" (click)="prevFileClicked()" *ngIf="selectedShareIndex !== -1 && getSortedFilteredShares()[selectedShareIndex].docs.length > 0" [disabled]="isFirstDoc()">Prev</button>
			<button class="btn btn-light btn-md" (click)="nextFileClicked()" *ngIf="selectedShareIndex !== -1 && getSortedFilteredShares()[selectedShareIndex].docs.length > 0" [disabled]="isLastDoc()">Next</button>

		</div>
		<div class="col-md-6">
			<button tooltip="Metadata" class="btn btn-light btn-md" (click)="loadDocProperties()"><em class="fas fa-list"></em></button>
			<button tooltip="Comments" class="btn btn-light btn-md" *ngIf="getSortedFilteredShares()[selectedShareIndex].permissions && getSortedFilteredShares()[selectedShareIndex].permissions.indexOf(2) > -1" (click)="loadComments()"><em class="fas fa-comments"></em></button>
			<button tooltip="Document Viewer" class="btn btn-light btn-md" (click)="loadViewer()"><em class="fas fa-file-alt"></em></button>
			<button class="btn btn-light btn-md" (click)="closeViewerModal()">Close</button>
		</div>
	</div>
</ng-template>

<ng-template #docShareModalModal>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-share"></em>Select a Share Link</h5>
	</div>
	<div class="modal-body share-links">
		<table>
			<!--
			<tr>
				<th>Scope</th>
				<th>Permissions</th>
				<th></th>
			</tr>
			-->
			<tr *ngFor="let link of shareLinkTarget.links">
				<ng-container *ngIf="link.scope !== 4 && link.scope !== 5">
					<td *ngIf="link.scope == 1">
						{{ getScopeName(link.scope) }}
					</td>
					<td *ngIf="link.scope == 2">
						{{ getScopeName(link.scope) }} - {{ link.orgName }}
					</td>
					<td *ngIf="link.scope == 3">
						{{ getScopeName(link.scope) }} - {{ link.groupName }}
					</td>
					<td>
						<span class="permission-icon">
							<em tooltip="View" placement="bottom" class="fa fa-file-alt"></em>
						</span>
						<span class="permission-icon">
							<em tooltip="Download" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.download : link.permissions?.indexOf(5) == -1 }" class="fa fa-file-download"></em>
						</span>
						<!--
						<span class="permission-icon">
							<em tooltip="Delete" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.delete : link.permissions?.indexOf(4) == -1 }" class="fa fa-trash"></em>
						</span>
						-->
						<span class="permission-icon">
							<em tooltip="Update Metadata" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.updateMetadata : link.permissions?.indexOf(7) == -1 }" class="fa fa-edit"></em>
						</span>
						<span class="permission-icon">
							<em tooltip="Update Document" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.updateDocument : link.permissions?.indexOf(6) == -1 }" class="fa fa-file-upload"></em>
						</span>
						<span class="permission-icon">
							<em tooltip="Upload File" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.create : link.permissions?.indexOf(3) == -1 }" class="fa fa-upload"></em>
						</span>
						<span class="permission-icon" *ngIf="commentsEnabled">
							<em tooltip="Comment" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.comment : link.permissions?.indexOf(2) == -1 }" class="fa fa-comment"></em>
						</span>
						<span class="permission-icon" *ngIf="coauthorEnabled">
							<em tooltip="Coauthor" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.coauthor : link.permissions?.indexOf(9) == -1 }" class="fa fa-user-edit"></em>
						</span>
						<span class="permission-icon">
							<em tooltip="Remove File from Share" placement="bottom" [ngClass]="{'disabled': link === linkToEdit ? !formattedLink.removeFromShare : link.permissions?.indexOf(10) == -1 }" class="fa fa-folder-minus"></em>
						</span>
					</td>
					<td class="right">
						<button (click)="copyShareLink(link, shareDocTarget)" class="btn copy">Copy Link</button>
					</td>
				</ng-container>
			</tr>
		</table>
	</div>
	<!--
	<div class="modal-footer message-footer">
		<button type="button" class="btn btn-md" (click)="modalRef.hide()">Close</button>
	</div>
-->
</ng-template>

<ng-template #advancedSearchModal>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-magnifying-glass"></em>Advanced Search</h5>
	</div>
	<div class="modal-body advanced-search-modal" [ngClass]="{'loading in': advancedSearchLoading }">
		<ng-container *ngIf="advancedSearchMode === 'views'">
			<app-view-widget [view]="advancedSearchView" (fileToggledEvent)="addRemoveAdvancedSearchTarget($event.item, $event.e)"></app-view-widget>
		</ng-container>
		<ng-container *ngIf="advancedSearchMode === 'filters'">
			<div class="row">
				<div class="col-md-4">
					<div>
						<label for="searchFilter">Filters</label>
						<select class="form-control" id="searchFilter" [(ngModel)]="advancedSearchDisplayedFilter" (ngModelChange)="advancedSearchFilterAdded($event)">
							<option></option>
							<option *ngIf="!advancedSearchDisplayedFilters['searchTerm']" value="searchTerm">Title/Name</option>
							<option *ngIf="!advancedSearchDisplayedFilters['createdBy']" value="createdBy">Created By</option>
							<option *ngIf="!advancedSearchDisplayedFilters['createdBefore']" value="createdBefore">Created Before</option>
							<option *ngIf="!advancedSearchDisplayedFilters['createdAfter']" value="createdAfter">Created After</option>
							<option *ngIf="!advancedSearchDisplayedFilters['modifiedBy']" value="modifiedBy">Modified By</option>
							<option *ngIf="!advancedSearchDisplayedFilters['modifiedBefore']" value="modifiedBefore">Modified Before</option>
							<option *ngIf="!advancedSearchDisplayedFilters['modifiedAfter']" value="modifiedAfter">Modified After</option>
						</select>
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['searchTerm']">
						<label for="searchTerm">Title/Name&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('searchTerm', -1)"><em class="fa fa-times red"></em></a></label>
						<input type="text" id="searchTerm" class="form-control" [(ngModel)]="advancedSearchTerm">
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['createdBy']">
						<label for="createdBy">Created By&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('createdBy', 25)"><em class="fa fa-times red"></em></a></label>
						<ng-select class="typeahead" id="createdBy" [items]="mfilesUsers" [clearable]="true" bindLabel="name" bindValue="id" [(ngModel)]="advancedSearchFilters[25]"></ng-select>
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['createdBefore']">
						<label for="createdBefore">Created Before&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('createdBefore', '20lt')"><em class="fa fa-times red"></em></a></label>
						<input class="form-control" id="createdBefore" bsDatepicker [(ngModel)]="advancedSearchFilters['20lt']">
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['createdAfter']">
						<label for="createdAfter">Created After&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('createdAfter', '20gt')"><em class="fa fa-times red"></em></a></label>
						<input class="form-control" id="createdAfter" bsDatepicker [(ngModel)]="advancedSearchFilters['20gt']">
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['modifiedBy']">
						<label for="modifiedBy">Modified By&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('modifiedBy', 23)"><em class="fa fa-times red"></em></a></label>
						<ng-select class="typeahead" id="modifiedBy" [items]="mfilesUsers" [clearable]="true" bindLabel="name" bindValue="id" [(ngModel)]="advancedSearchFilters[23]"></ng-select>
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['modifiedBefore']">
						<label for="modifiedBefore">Modified Before&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('modifiedBefore', '21lt')"><em class="fa fa-times red"></em></a></label>
						<input class="form-control" id="modifiedBefore" bsDatepicker [(ngModel)]="advancedSearchFilters['21lt']">
					</div>
					<div *ngIf="advancedSearchDisplayedFilters['modifiedAfter']">
						<label for="modifiedAfter">Modified After&nbsp;<a href="javascript:" (click)="advancedSearchFilterRemoved('modifiedAfter', '21gt')"><em class="fa fa-times red"></em></a></label>
						<input class="form-control" id="modifiedAfter" bsDatepicker [(ngModel)]="advancedSearchFilters['21gt']">
					</div>
					<div>
						<button type="button" class="btn btn-md pull-right" [disabled]="advancedSearchLoading" (click)="performAdvancedSearch()">Search</button>
					</div>
				</div>
				<div class="col-md-8">
					<table class="advanced-search-table" *ngIf="advancedSearchRan && advancedSearchResults.length !== 0">
						<tr>
							<th class="checkbox-column"></th>
							<th class="sort title-column" (click)="updateSearchSort('title')">Title <em *ngIf="advancedSearchSortCol == 'title' && !advancedSearchSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="advancedSearchSortCol == 'title' && advancedSearchSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
							<th class="sort" (click)="updateSearchSort('created')">Created <em *ngIf="advancedSearchSortCol == 'created' && !advancedSearchSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="advancedSearchSortCol == 'created' && advancedSearchSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
							<th class="sort" (click)="updateSearchSort('lastModified')">Last Modified <em *ngIf="advancedSearchSortCol == 'lastModified' && !advancedSearchSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="advancedSearchSortCol == 'lastModified' && advancedSearchSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
						</tr>
						<tr *ngFor="let item of getSortedAdvancedSearchResults()">
							<td class="checkbox-column"><input class="form-control file-selector" type="checkbox" [id]="item.objVer.id" (change)="addRemoveAdvancedSearchTarget(item, $event)"></td>
							<td>
								<em class="icon icon-file icon-other preview-icon" [ngClass]="item?.extension !== undefined ? 'icon-' + item?.extension : ''" [title]="item?.extension !== undefined ? item.extension + ' File' : 'Shared File'"></em>
								<label [for]="item.objVer.id">{{ item.title }}</label>
							</td>
							<td>
								{{ item.created | date: defaultDateFormat ?? 'shortDate' }}
							</td>
							<td>
								{{ item.lastModified | date: defaultDateFormat ?? 'shortDate' }}
							</td>
						</tr>
					</table>
					<div *ngIf="advancedSearchRan && advancedSearchResults.length === 0">
						No results found
					</div>
					<div *ngIf="!advancedSearchRan">
						Add a filter to perform a search.
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="modal-footer message-footer">
		<button *ngIf="advancedSearchMode !== 'views'" type="button" class="btn pull-left btn-md" (click)="changeAdvancedSearchMode('views')">Browse for Documents</button>
		<button *ngIf="advancedSearchMode !== 'filters'" type="button" class="btn pull-left btn-md" (click)="changeAdvancedSearchMode('filters')">Search Using Filters</button>
		<button type="button" class="btn btn-md" (click)="modalRef.hide()">Cancel</button>
		<button type="button" class="btn btn-md" (click)="addToAdvancedSearchShare()" [disabled]="advancedSearchTargets.length === 0">Add to Share</button>
	</div>
</ng-template>

<ng-template #downloadProgressModal>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-file-download"></em>{{ docToDownload.name }}{{ docToDownload.extension ? '.' + docToDownload.extension : '' }}</h5>
	</div>
	<div class="modal-body">
		<div class="download-progress-container">
			<div class="download-progress-bar">
				<mat-progress-bar mode="determinate" [value]="downloadProgress">
				</mat-progress-bar>
			</div>
			<div class="download-progress-num">{{downloadProgress}}%</div>
		</div>
	</div>
	<div class="modal-footer message-footer">
		<button type="button" class="btn btn-md btn-danger" (click)="cancelDownload()">Cancel</button>
	</div>
</ng-template>

<ng-template #uploadProgressModal>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-upload"></em>Uploading Files</h5>
	</div>
	<div class="modal-body upload-progress-modal-body" [ngClass]="{'loading in': uploadsCommitting}" [ngStyle]="{'overflow-y': uploadsCommitting ? 'hidden' : 'auto'}">
		<div *ngFor="let progress of uploadProgressStats | keyvalue" class="upload-progress-section">
			<div>{{ progress.key }}</div>
			<ng-container *ngIf="progress.value === 'ERROR'; else elseTemplate">
				<div class="upload-progress-error">
					<em class="fas fa-exclamation-circle error"></em>
					An error occurred while uploading this file. Please try again later.
				</div>
			</ng-container>
			<ng-template #elseTemplate>
				<ng-container *ngIf="progress.value === 'EMPTY'; else notEmptyTemplate">
					<div class="upload-progress-empty">
						<em class="fas fa-exclamation-triangle"></em>
						This file has no content. It will be skipped.
					</div>
				</ng-container>
				<ng-template #notEmptyTemplate>
					<div class="upload-progress-container">
						<div class="upload-progress-bar">
							<mat-progress-bar mode="determinate" [value]="progress.value">
							</mat-progress-bar>
						</div>
						<div class="upload-progress-num">{{ progress.value }}%</div>
					</div>
				</ng-template>
			</ng-template>

		</div>
	</div>
	<div class="modal-footer message-footer">
		<span id="uploadProgressMessage">{{ uploadProgressMessage }}</span>
		<button type="button" class="btn btn-md btn-danger" (click)="cancelUpload()">Cancel</button>
	</div>
</ng-template>